const audioCache = new Map<string, HTMLAudioElement>();

/** Reproduce un sonido de percusión corporal. Silencioso si el archivo no existe aún. */
export function playPercusionSound(path: string): void {
  try {
    let audio = audioCache.get(path);
    if (!audio) {
      audio = new Audio(path);
      audio.preload = 'auto';
      audioCache.set(path, audio);
    }
    audio.currentTime = 0;
    void audio.play().catch(() => {});
  } catch {
    /* sonido opcional — el usuario añadirá los archivos */
  }
}

/** Precarga sonidos al iniciar una partida. */
export function preloadPercusionSounds(paths: string[]): void {
  for (const path of paths) {
    if (!audioCache.has(path)) {
      const audio = new Audio(path);
      audio.preload = 'auto';
      audioCache.set(path, audio);
    }
  }
}
